import Svg from '@doordash/component-svg'
import * as React from 'react'
import { IconProps } from './'

// tslint:disable:max-line-length
export const LongArrowIcon: React.SFC<IconProps> = ({ size, color }) => (
  <Svg height={size} width={size + 20} fill={color} viewBox="0 0 24 24 ">
    <path
      d="M21.293 15.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414L23.586 11H16a1 1 0 1 0 0 2h7.586l-2.293 2.293z"
      fill="#191919"
    />
    <circle cx="13" cy="12" r="1" fill="#000" />
    <circle cx="9" cy="12" r="1" fill="#000" />
    <circle cx="5" cy="12" r="1" fill="#000" />
    <circle cx="1" cy="12" r="1" fill="#000" />
  </Svg>
)

export default LongArrowIcon
